import Link from 'next/link'
import React from 'react'
import styled, { css } from 'styled-components'
import Newsletter from '../components/Newsletter'
import ReactHtmlParser from "react-html-parser"
import { breakpoint } from './styles'
import NoSSR from 'core/helpers/nossr'
import { Button } from './Common'
import PopUp from '../components/Popup'
import { useRouter } from 'next/router'

const Footer = ({ footer }: any) => {
  const router = useRouter();
  const { asPath } = router;
  let trigger_popup = false;
  if(footer?.pop_up?.show_popup) {
    footer.pop_up.uid = footer.uid;
    const { pop_up } = footer;
    (pop_up.uris ?? []).forEach((item : string) => {
      trigger_popup = String(asPath).includes(`/${item}`);
      if(trigger_popup) {
        return;
      }
    })

    if(pop_up.include_home_page && !trigger_popup) {
      trigger_popup = asPath === '/';
    }
  }
  return (
    <>
      {footer.newsletter?.show_component &&
        <Newsletter item={footer.newsletter} />}
      <Container>
        <Logo>
          <img src={`${footer.logo?.url}?width=${200}&auto=webp&format=png`} alt={footer.logo?.description} aria-hidden="true" width={200} height={114} />
        </Logo>
        <Navigation>
          <ul>
            {footer.navigation?.group?.map((group: any) =>
              <li key={group._metadata.uid}>
                <b>{group.heading}</b>
                <NoSSR>
                  <ul>
                    {group.link.map((link: any) =>
                      <li key={link.title}>
                        <Link href={link.href}>
                          <a>{ReactHtmlParser(link.title)}</a>
                        </Link>
                      </li>)}
                  </ul>
                </NoSSR>
              </li>)}
          </ul>
        </Navigation>
        <section>
          {footer.newsletter_cta &&
            <NewsletterCTASection>
              {footer.newsletter_cta.description &&
                <NewsletterCTATitle>
                  {footer.newsletter_cta.description}
                </NewsletterCTATitle>
              }
              {footer.newsletter_cta.url && footer.newsletter_cta.url.href &&
                <Link href={footer.newsletter_cta.url?.href} passHref>
                  <NewsletterCTA as="a">{footer.newsletter_cta.url?.title}</NewsletterCTA>
                </Link>
              }
            </NewsletterCTASection>
          }
          <Social useBigSpace={footer.newsletter_cta}>
            {footer.social?.social_share?.map((item: any) =>
              <Link href={item.link.href} key={item._metadata.uid}>
                <a target="_blank" rel="noopener noreferrer">
                  <img src={`${item.icon?.url}?auto=svg`} alt={item.link.title} width={25} height={25} />
                </a>
              </Link>)}
          </Social>
          <Copyright>
            {ReactHtmlParser((footer.copyright ?? '').replace(/\[year\]/ig, (new Date()).getFullYear()))}
          </Copyright>
        </section>
        {footer?.pop_up && trigger_popup && (
          <PopUp
            data={footer?.pop_up}
            key={`popup-${footer?.uid}`}
          ></PopUp>
        )}
      </Container>
    </>
  )
}

export default Footer

export const Container = styled.footer`
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: center;
  @media ${breakpoint.desktop} {
    flex-direction: row;
    text-align: inherit;
  }
  justify-content: space-between;
  padding: 4rem 0 2rem;
  @media print {
    display: none;
  }
`

export const Logo = styled.div`
  @media ${breakpoint.desktop} {
    margin-right: 4rem;
  }
  img {
    height: auto;
    width: 150px;
  }
`

export const Navigation = styled.nav`
  ul, li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  & > ul {
    display: flex;
    flex-direction: column;
    @media ${breakpoint.desktop} {
      flex-direction: row;
    }
    ul {
      width: inherit;
      @media ${breakpoint.desktop} {
        width: 200px;
      }
      li {
        margin: 10px 0;
        font-size: 18px;
        font-weight: 400;
        line-height: 26px;
        &, a {
          color: var(--secondary);
          text-decoration: none;

          sup {
            font-size: 12px;
          }
        }
      }
    }
  }
  b {
    display: block;
    margin: 4rem 0 1rem 0;
    font-size: 18px;
    font-weight: 700;
    line-height: 25px;
    color: var(--text);
    @media ${breakpoint.desktop} {
      margin: 0 0 1rem 0;
    }
  }
`

export const NewsletterCTASection = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4rem;

  @media ${breakpoint.desktop} {
    margin-top: 0;
  }
`

const NewsletterCTATitle = styled.span<any>`
  display: inline-block;
  font-size: 18px;
  font-weight: 700;
  line-height: 20.8px;
  text-transform: capitalize;
  color: var(--text);
  margin-bottom: 16px;
`

const NewsletterCTA = styled(Button)``

export const Social = styled.div<any>`
  display: flex;
  justify-content: center;
  margin-top: ${props => props.mt || 4}rem;
  @media ${breakpoint.desktop} {
    margin-top: 0;
    justify-content: ${props => props.center ? 'center' : 'space-between'};
    ${props => !props.useBigSpace && css`
      padding-top: 100px !important;
    `}
  }
  a {
    display: block;
    margin: 0 ${props => `${props.margin || 12}px`};
    @media ${breakpoint.desktop} {
      margin: 0 ${props => `${props.margin || 24}px`};
    }
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  @media print {
    display: none;
  }
`

const Copyright = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin-top: 2.5rem;
  text-align: center;
  &, a {
    color: var(--secondary);
    text-decoration: none;
  }
  p {
    margin: 2rem 0;
  }
`